__webpack_require__.p = "https://assets.worldcubeassociation.org/assets/73c1ba8/packs/";